var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93981 6.88473C2.02328 6.09913 2.57884 4.59729 3.78599 4.59729H17.4516C18.4623 4.59729 19.0866 5.69985 18.5666 6.56648L11.7181 17.9807C11.1136 18.9882 9.58875 18.7407 9.33386 17.5938L7.89861 11.1351L2.93981 6.88473ZM9.66926 11.1114L10.7905 16.157L15.8613 7.70578L9.66926 11.1114ZM14.7636 6.33093H4.95761L8.79041 9.61619L14.7636 6.33093Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramShare);
export default __webpack_public_path__ + "static/media/instagramShare.51fbcf96.svg";
export { ForwardRef as ReactComponent };